import { request } from '@/lib/axios'

interface GetImeiMsg {
  imei: string;
}

export async function getImeiMsg (params: GetImeiMsg) {
  return request('/eqApi/v1/weixin/get_res_by_imei', {
    method: 'GET',
    payload: params
  })
}
